var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"logo",class:_vm.classNames},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }